import React from "react";

import { CustomersReportController } from "../../../../services/controllers/reports";
import { useCustomersReport } from "../../../../store/reports/useCustomersReport";
import { formatMoney } from "../../../../services/functions";

import { AbsenceBadge } from "../../../../components/ui/AbsenceBadge";
import { Pagination } from "../../../../components/ui/Pagination";
import { Table } from "../../../../components/ui/Table";

const SORTABLE_COLUMN_KEYS = {
  Cliente: "name",
  CPF: "cpf",
  Telefone: "cellphone",
  "Ticket médio": "averageTicket",
  "Receita total": "totalSales",
  Agendamentos: "totalAppointments",
  "Última visita": "lastAppointment",
  Ausência: "absenceDays",
  "Tem pacote": "hasPackage",
};

function YesNo({ value }) {
  if (!value) return <span className="text-gray-400">Não</span>;
  return <span className="font-semibold text-scale-600">Sim</span>;
}

export function CustomersReportTable() {
  const CCustomersReport = CustomersReportController();

  const page = useCustomersReport((st) => st.data.pagination.page);
  const paginationData = useCustomersReport((st) => st.data.pagination);
  const customers = useCustomersReport((st) => st.data.customersReport);
  const sort = useCustomersReport((st) => st.data.sort);
  const isWaiting = useCustomersReport((st) => st.data.isWaiting);

  return (
    <Table.Root name={CCustomersReport.tableName} config>
      <Table.Header
        columns={[
          "Cliente:minmax(150px, 260px)",
          "CPF:120px",
          "Telefone:115px",
          "Ticket médio:105px",
          "Receita total:105px",
          "Agendamentos:110px",
          "Última visita:105px",
          "Ausência:100px",
          "Tem pacote:95px",
        ]}
        sortableConfig={{
          sortBy: sort.sortBy,
          sortOrder: sort.sortOrder,
          onSort: CCustomersReport.handleSortColumn,
          columnKeys: SORTABLE_COLUMN_KEYS,
        }}
      />

      <Table.Content isLoading={isWaiting}>
        {!!customers[page] &&
          customers[page].map((customer) => (
            <Table.Line key={customer.id}>
              <Table.Item title={customer.name}>{customer.name}</Table.Item>
              <Table.Item>{customer.cpfLabel}</Table.Item>
              <Table.Item>{customer.cellphone}</Table.Item>
              <Table.Item className="text-right">
                R$ {formatMoney(customer.averageTicket)}
              </Table.Item>
              <Table.Item className="text-right">
                R$ {formatMoney(customer.totalSales)}
              </Table.Item>
              <Table.Item className="text-right">{customer.totalAppointments}</Table.Item>
              <Table.Item>{customer.lastAppointment || "-"}</Table.Item>
              <Table.Item>
                <AbsenceBadge days={customer.absenceDays} />
              </Table.Item>
              <Table.Item>
                <YesNo value={customer.hasPackage} />
              </Table.Item>
            </Table.Line>
          ))}
      </Table.Content>

      <Pagination.Root
        name={CCustomersReport.paginationName}
        totalPages={paginationData.totalPages}
        currentPage={paginationData.page}
        onChange={CCustomersReport.setPage}
      >
        <Pagination.Back />
        <Pagination.Pages />
        <Pagination.Forward />
      </Pagination.Root>
    </Table.Root>
  );
}
